import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import { ValidationFormTypes } from "../../../../Pages/SubmitProccess/ValidationForm/ValidationForm";
import { setValidationData } from "../../validationData/validationData";
import { resetFiles } from "../../files/uploadedFiles/uploadedFiles";

export type DeleteUserSessionFilesLoadAction = {
  type: string;
  payload: ValidationFormTypes;
};

export type DeleteUserSessionFilesData = {
  data: {};
};

export const DeleteUserSessionFiles = new ReduxFetchState<
  DeleteUserSessionFilesData,
  ValidationFormTypes,
  any
>("deleteUserSessionFiles");

export function* watchDeleteUserSessionFiles(
  action: DeleteUserSessionFilesLoadAction,
) {
  try {
    const { id, file_ids, question_id, file_link, user_service_id } =
      action.payload;

    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: DeleteUserSessionFilesData = yield axios({
      url: `/api/v1/ai/user-session-files/delete-files`,
      method: "POST",
      headers: {
        lang,
      },
      data: { file_ids, user_service_id },
    });

    yield put(DeleteUserSessionFiles.actions.loadSuccess({ data: data.data }));
    yield put(resetFiles());
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(DeleteUserSessionFiles.actions.loadFailure(e.message));
  }
}

export function* deleteUserSessionFilesSagas() {
  yield takeEvery(
    DeleteUserSessionFiles.actionTypes.load,
    watchDeleteUserSessionFiles,
  );
}

export function useDeleteUserSessionFiles() {
  const { loading, data, ...deleteUserSessionFilesState } = useAppSelector(
    (state) => state.deleteUserSessionFiles,
  );
  const dispatch = useAppDispatch();

  const dispatchDeleteUserSessionFiles = useCallback(
    (data: ValidationFormTypes) => {
      dispatch(DeleteUserSessionFiles.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...deleteUserSessionFilesState,
    dispatchDeleteUserSessionFiles,
    deleteUserSessionFilesLoading: loading,
    deleteUserSessionFilesData: data,
  };
}

export const {
  actionTypes: deleteUserSessionFilesActionsTypes,
  actions: deleteUserSessionFilesActions,
  reducer: deleteUserSessionFilesReducer,
} = DeleteUserSessionFiles;
